/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';

const { api } = vopayApi;

export function useSubAccountPermissions() {
  const source = axios.CancelToken.source();

  // State
  const [permissions, setPermissions] = useState<vp.SubAccountPermissionSection[]>([]);
  const [loadingPermissions, setLoadingPermissions] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchSubAccountPermissions(params: vp.SubAccountPermissionsRequest) {
    try {
      setLoadingPermissions(true);
      const res = await api.fetchSubAccountPermissions(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setPermissions(res.PermissionValues);
      return res;
    } catch (err) {
      setPermissions([]);
      console.error(err);
      throw err;
    } finally {
      setLoadingPermissions(false);
    }
  }

  async function saveSubAccountPermissions(params: vp.EditAccountPermissionsRequest) {
    try {
      const res = await api.saveSubAccountPermissions(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
    }
  }

  return {
    permissions,
    loadingPermissions,
    fetchSubAccountPermissions,
    saveSubAccountPermissions,
  };
}

// Default export for backward compatibility
export default useSubAccountPermissions;
